import { Component, Input } from '@angular/core';
import { FormControl, FormRecord, ReactiveFormsModule } from '@angular/forms';
import { Filter } from '../../../shared/models/filter.model';
import { FilterOption } from '../../../shared/interfaces/filteroption.interface';
import { EventBus } from '../../../shared/utils/eventbus';

@Component({
  selector: 'app-filtertype-checkbox',
  templateUrl: 'filter.checkbox.component.html',
  imports: [ReactiveFormsModule],
})
export class FilterCheckboxComponent {
  // Get the data from the parent
  @Input() filterOption?: FilterOption;
  @Input() form?: FormRecord<FormRecord<FormControl<boolean>>>;
  @Input() formControl = '';
  @Input() filter: Filter = new Filter();

  constructor(private eventBus: EventBus) {}

  get count() {
    return (this.filterOption?.count ?? 0) <= 0;
  }

  public eventEmit(option: string) {
    this.eventBus.emit('filterApp.checkFilter', option);
  }
}
